export const localStorageName = {
    redirect : 'redirect',
    errorClave: 'errorClave',
    token: 'token',
    refresh_token: 'refresh_token',
    username: 'username',
    expiredTime: 'expiredTime',
    expiredTimeRefresh: 'expiredTimeRefresh',
    obteniendo_token: 'loading',
    permissions: 'permissions',
    credencialGuardada: 'credencialGuardada',
    popUp: 'miniApplet'
}